import React, {useCallback, useEffect, useState} from 'react';
import Flux                                      from '../../flux/Flux.js';
import debounce                                  from 'lodash.debounce';

const withFeatureFeedback = (WrappedComponent) => {
    const WithFeatureFeedback = (props) => {
        const [isSubmittingRating, setIsSubmittingRating] = useState(false);
        const [isSent, setIsSent]                         = useState(false);

        const onSuccess = () => {
            Flux.Guest.removeFeatureFeedbackSentListener(onSuccess);
            setIsSubmittingRating(false);
            setIsSent(true);
        };

        const debouncedOnSubmit = useCallback(
                debounce((featureId, selectedRating, text) => {
                    setIsSubmittingRating(true);
                    Flux.Guest.addFeatureFeedbackSentListener(onSuccess);
                    Flux.Guest.sendFeatureFeedback(
                            featureId,
                            selectedRating,
                            text,
                            window.location.href
                    );
                }, 300),
                []
        );

        // clean up the debounced function
        useEffect(() => () => {
            debouncedOnSubmit.cancel();
        }, [debouncedOnSubmit]);

        // trigger opening
        const onClear = () => {
            setIsSent(false);
        };
        useEffect(() => {
            Flux.Guest.addFeatureFeedbackSetListener(onClear);

            return () => {
                Flux.Guest.removeFeatureFeedbackSetListener(onClear);
            };
        }, []);

        return (
                <WrappedComponent
                        {...props}
                        onSubmit={debouncedOnSubmit}
                        isSubmittingRating={isSubmittingRating}
                        isSent={isSent}
                />
        );
    };

    // Set the display name of the wrapped component
    WithFeatureFeedback.displayName = `WithFeatureFeedback(${
            WrappedComponent.displayName || WrappedComponent.name
    })`;

    return WithFeatureFeedback;
};

export default withFeatureFeedback;
